import ResultClickedEventRecord from "models/view-models/search-events/result-clicked-event.record";
import SearchSubmittedEventRecord from "models/view-models/search-events/search-submitted-event.record";
import ServiceHookFactory from "utilities/services/service-hook-factory";

// -----------------------------------------------------------------------------------------
// #region Constants
// -----------------------------------------------------------------------------------------

const baseEndpoint = "events";
const searchSubmittedEventResourceType = SearchSubmittedEventRecord;
const resultClickedEventRecordResourceType = ResultClickedEventRecord;

// #endregion Constants

// -----------------------------------------------------------------------------------------
// #region Service
// -----------------------------------------------------------------------------------------

const SearchEventsService = {
    useSearchSubmittedEvent:
        ServiceHookFactory.useCreate<SearchSubmittedEventRecord>(
            searchSubmittedEventResourceType,
            baseEndpoint
        ),
    useResultClickedEvent:
        ServiceHookFactory.useCreate<ResultClickedEventRecord>(
            resultClickedEventRecordResourceType,
            baseEndpoint
        ),
};

// #endregion Service

// -----------------------------------------------------------------------------------------
// #region Exports
// -----------------------------------------------------------------------------------------

export default SearchEventsService;

// #endregion Exports
